export const API_URL = process.env.REACT_APP_API_URL || 'https://yvsoqivtcb.execute-api.us-east-1.amazonaws.com/dev';
export const STRIPE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_51TM1HlEs23VwcjKqjuwJ0E183sOVyZgWsvERvNxxztK0ZyaBroYLOWFsC3Nyi4UULr9Y36nOmyiEkQcc1Bsbu8IK00FuT9OAKk';

// Pricing
export const HOME_ASSESSMENT_PRICE = 249.99;
export const BUSINESS_ASSESSMENT_PRICE = 599.99;

export const INTERN_EARNINGS_HOME = 140;
export const INTERN_EARNINGS_BUSINESS = 240;
export const MIN_GPA = 3.0;
export const MIN_ASSESSMENT_SCORE = 80;
export const BOOKING_EXPIRATION_HOURS = 24;
